import { render } from "./Tabswrapper.vue?vue&type=template&id=c62847be&scoped=true"
import script from "./Tabswrapper.vue?vue&type=script&lang=js"
export * from "./Tabswrapper.vue?vue&type=script&lang=js"

import "./Tabswrapper.vue?vue&type=style&index=0&id=c62847be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\tmeadows\\WebstormProjects\\tuitioncalculator\\vue-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c62847be"]])

export default __exports__